import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { OptionFormGroup } from '@/App/tiles/Option/fields/OptionFormGroup.tsx';
import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useCheckOption } from '@/App/tiles/Option/QueueContext.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { selectOptionLegsProperties, selectOptionLegsValidation } from '@/store/option/selectors/optionSelectors.ts';
import type { LegId } from '@/store/option/state.ts';

type DeliveryProps = {
  tileId: string;
};

export function Delivery({ tileId }: DeliveryProps) {
  const [checkOption] = useCheckOption();
  const legId: LegId = `${tileId}/0`;

  const { sgwtWebAnalytics } = useSgwtWidgets();

  const { deliveryDate, validation } = useOptionSelector((option) => {
    const legProperties = selectOptionLegsProperties(option, legId);
    const validation = selectOptionLegsValidation(option, legId)?.deliveryDate;

    return {
      deliveryDate: legProperties?.deliveryDate,
      deliveryDateTenor: legProperties?.deliveryDateTenor,
      validation,
    };
  });

  const handleDeliveryDateSelected = (dateOrTenor: string) => {
    sgwtWebAnalytics?.trackEvent('Option', 'Delivery date selected', dateOrTenor);

    checkOption({
      tileId,
      legProperties: {
        legId,
        deliveryDate: dateOrTenor,
      },
    });
  };
  return (
    <OptionFormGroup label={<FormattedMessage id="option.fields.delivery" />}>
      <TradeCaptureValidationWrapper validation={validation}>
        <DatePickerWithTenorNext data-e2e="delivery-date" date={deliveryDate} onChange={handleDeliveryDateSelected} />
      </TradeCaptureValidationWrapper>
    </OptionFormGroup>
  );
}
